import { Injectable } from '@angular/core';

import { PruHttpService } from '../pru-http.service';

import { AggregationService } from '../../services/aggregation.service';
import { HomeinitService } from '../homeinit.service';
import { SessionStorageService } from '../web-storage/session-storage.service';

import { deferredWarmupMappings } from './deferred-warmup-mappings';

@Injectable({
  providedIn: 'root'
})
/**
 * The goal of this service to initiate any deferred warm up call per BU if needed. These are kind of fire and forget.
 * The output of the warmup might be applied to later user actions in MyPru applications.
 * It started with basic configuration. This can be expanded as we go.
 * Moving this to an API layer is also can be considered as we expand this feature.
 */
export class DeferredWarmupService {
  private AGGREGATION_EVENT = 'aggregationDone';
  private INITIATION_MARKER = 'maDefWarmDone';

  constructor(
    private sessionStorageService: SessionStorageService,
    private pruHttpService: PruHttpService,
    private aggregationService: AggregationService,
    private homeinitService: HomeinitService
  ) {}

  init(): void {
    this.aggregationService.aggregationDone.subscribe((res: any) => {
      if (res && res === this.AGGREGATION_EVENT) {
        this.startDeferredWarmup();
      }
    });
  }

  private startDeferredWarmup(): void {
    if (this.sessionStorageService.getItem(this.INITIATION_MARKER)) {
      return;
    }

    const buNames: string[] = (this.homeinitService.appConfiguration && this.homeinitService.appConfiguration.buNames) || [];

    if (buNames.length === 0) {
      return;
    }

    let isAnyBUTriggered = false;

    for (const buName of buNames) {
      const mappingInfo = this.getMappingByBU(buName);

      if (mappingInfo) {
        this.deferWarmupBU(mappingInfo);

        isAnyBUTriggered = true;
      }
    }

    if (isAnyBUTriggered) {
      this.sessionStorageService.setItem(this.INITIATION_MARKER, 'Y');
    }
  }

  private deferWarmupBU(mappingInfo: any): void {
    this.pruHttpService.get(mappingInfo.apiUrl, 'DeferredWarmup').subscribe(() => {});
  }

  private getMappingByBU(buName: string): any {
    return deferredWarmupMappings[buName.toLowerCase()];
  }
}
